<!-- 单个玩家沟通页 -->
<template>
  <div class="game-1">
    <nf-card
      borderInnerSize="0"
      round=".2rem"
      v-if="gameInfo.gameStatus == 1"
      bgColor="#fff"
    >
      <div class="game-1-box">
        <div v-if="formValue.cardList.length > 0">
          {{ nickname }}本轮的选择：
        </div>
        <!-- <div class="game-1-box-title">当前：第1/8页</div> -->
        <div class="game-1-box-list" v-if="gameInfo.visibleType != 'wheel'">
          <!-- 左右滑动，一个Swipeitem中有8张图片，一行4个 -->
          <template v-if="formValue.cardList.length > 0">
            <Grid :column-num="3" :border="false">
              <GridItem
                v-for="(subitem, subindex) in formValue.cardList"
                :key="subindex"
              >
                <NfBrand
                  trigger="custom"
                  height="2.8rem"
                  :onlyKey="`brand-${subindex}`"
                  v-model="brandStatus"
                >
                  <template #cz>
                    <VanImage
                      height="2.8rem"
                      width="100%"
                      :src="
                        subitem.isFront != 1
                          ? subitem.reverseImg
                          : subitem.frontImg
                      "
                      fit="fill"
                      radius="5"
                    />
                  </template>
                  <template #cf>
                    <VanImage
                      height="2.8rem"
                      width="100%"
                      :src="
                        subitem.isFront != 1
                          ? subitem.frontImg
                          : subitem.reverseImg
                      "
                      fit="fill"
                      radius="5"
                    />
                  </template>
                  <div
                    class="game-1-box-list-open"
                    @click.stop="previewImgHandle(subitem)"
                  >
                    <Icon name="search" size="0.3rem" />
                  </div>
                </NfBrand>
              </GridItem>
            </Grid>
          </template>
          <template v-else>
            <div class="game-1-box-list-empty">
              <Empty description="还未抽取卡牌" />
            </div>
          </template>
          <template v-if="gameInfo.flip">
            <NfButton
              color="rgb(255,211,94)"
              round=".5rem"
              style="margin-top: 0.2rem"
              @click.native="brandHandle"
              >{{ isOpen ? "（已启用）" : "" }}翻面</NfButton
            >
          </template>
        </div>
        <div class="game-1-box-list" v-else>
          <template v-if="formValue.cardList.length > 0">
            <WheelRecord :value="formValue.cardList" />
          </template>
          <template v-else>
            <div class="game-1-box-list-empty">
              <Empty description="用户还未打分" />
            </div>
          </template>
        </div>
      </div>
    </nf-card>
    <FrontSelectListVue
      :nickname="nickname"
      :value.sync="formValue.frontSelectCardList"
    />
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Empty,
  ImagePreview,
  Icon,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import NfBrand from "@/components/game-ui/NfBrand.vue";
import FrontSelectListVue from "@/components/game-comm/FrontSelectList.vue";
import WheelRecord from "@/components/game-comm/WheelRecord.vue";
import { getGameConfig } from "../../config";
import $store from "@/store";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
  },
  data() {
    return {
      // 翻面状态
      brandStatus: false,
      nickname: "我",
      isOpen: false,
    };
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    NfBrand,
    FrontSelectListVue,
    Empty,
    WheelRecord,
    ImagePreview,
    Icon,
  },
  methods: {
    brandHandle() {
      this.brandStatus = !this.brandStatus;
      this.$emit("flip");
    },
    previewImgHandle(item) {
      const img = item.brandStatus ? item.reverseImg : item.frontImg;
      ImagePreview({
        images: [img],
      });
    },
  },
  computed: {
    formValue: {
      get: () => {
        return $store.state.game.discus.form;
      },
      set: (val) => {
        $store.commit("GAME_DISCUS_FORM", val);
      },
    },
  },
  watch: {
    "formValue.roleTab": {
      handler(val) {
        this.nickname = this.formValue.playerList.find(
          (item) => item.id == val
        ).nickName;
        this.isOpen = this.formValue.playerList.find(
          (item) => item.id == val
        ).isOpen;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.2rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }

      &-open {
        position: absolute;
        top: -0.15rem;
        right: -0.15rem;
        border-radius: 50%;
        width: 0.6rem;
        height: 0.6rem;
        background: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }

  ::v-deep .van-grid {
    justify-content: center;
  }
}
</style>
